import {enumType} from 'common/enumType';

const Constants = {
   CLOUD_DEFAULT_PORT: 8082,
   FTP_DEFAULT_PORT: 21,
   FTPS_DEFAULT_PORT: 21,
   FTPS_IMPLICIT_DEFAULT_PORT: 990,
   HTTP_DEFAULT_PORT: 80,
   HTTPS_DEFAULT_PORT: 443,
   IMAP_DEFAULT_PORT: 143,
   POP3_DEFAULT_PORT: 110,
   SFTP_DEFAULT_PORT: 22,
   SMB_DEFAULT_PORT: 445,
   SMTP_DEFAULT_PORT: 25,
};

const transportType = (
   id: string,
   display: string,
   defaultInputPort: number,
   defaultOutputPort: number,
   sizeCheck: boolean,
   hashCheck: boolean,
   destinationOnly: boolean
) => ({
   id,
   display,
   defaultInputPort,
   defaultOutputPort,
   sizeCheck,
   hashCheck,
   destinationOnly,
});

export type TransportTypeObject = ReturnType<typeof transportType>;
export type TransportTypeUnion = keyof typeof TransportType.enum;

export const TransportType = enumType({
   AMAZONS3: transportType('Amazon S3', 'Amazon S3', -1, -1, true, false, false), //AMAZONS3
   AS2: transportType(
      'AS2',
      'AS2',
      Constants.HTTPS_DEFAULT_PORT,
      Constants.HTTPS_DEFAULT_PORT,
      false,
      false,
      true
   ), //AS2
   BISCOM: transportType('Biscom Transit', 'Biscom Transit', -1, -1, true, false, false),
   ONEDRIVE: transportType('OneDrive', 'Microsoft OneDrive', -1, -1, true, false, false),
   AZURE_STORAGE: transportType('Azure Storage', 'Microsoft Azure', -1, -1, true, false, false), //AZURE_STORAGE
   BOX: transportType('Box', 'Box', -1, -1, true, false, false), //BOX
   CLOUD: transportType(
      'Remote Agent',
      'Diplomat Remote Agent',
      Constants.CLOUD_DEFAULT_PORT,
      Constants.CLOUD_DEFAULT_PORT,
      true,
      true,
      false
   ), //CLOUD
   DROPBOX: transportType('Dropbox', 'Dropbox', -1, -1, true, false, false), //DROPBOX
   EMAIL: transportType(
      'EMAIL',
      'Email',
      Constants.POP3_DEFAULT_PORT,
      Constants.SMTP_DEFAULT_PORT,
      false,
      false,
      false
   ), //EMAIL
   FILE_SYSTEM: transportType('Local Network', 'Local Network', -1, -1, true, false, false), //FILE_SYSTEM
   FTP: transportType(
      'FTP',
      'FTP',
      Constants.FTP_DEFAULT_PORT,
      Constants.FTP_DEFAULT_PORT,
      true,
      false,
      false
   ), //FTP
   FTPS: transportType(
      'FTPS',
      'FTPS (TLS)',
      Constants.FTPS_DEFAULT_PORT,
      Constants.FTPS_DEFAULT_PORT,
      true,
      false,
      false
   ), //FTPS
   GOOGLE_CLOUD: transportType('Google Cloud', 'Google Cloud', -1, -1, true, false, false), //GOOGLE_CLOUD
   HTTP: transportType(
      'HTTP',
      'HTTP',
      Constants.HTTP_DEFAULT_PORT,
      Constants.HTTP_DEFAULT_PORT,
      true,
      false,
      false
   ), //HTTP
   HTTPS: transportType(
      'HTTPS',
      'HTTPS',
      Constants.HTTPS_DEFAULT_PORT,
      Constants.HTTPS_DEFAULT_PORT,
      true,
      false,
      false
   ), //HTTPS
   ORACLE_CLOUD: transportType('OracleCloud', 'Oracle Cloud', -1, -1, true, false, false), //ORACLE_CLOUD
   SFTP: transportType(
      'SFTP',
      'SFTP (SSH2)',
      Constants.SFTP_DEFAULT_PORT,
      Constants.SFTP_DEFAULT_PORT,
      true,
      false,
      false
   ), //SFTP
   SHAREFILE: transportType('ShareFile', 'ShareFile', -1, -1, true, false, false), //SHAREFILE
   SMB: transportType(
      'SMB',
      'SMB',
      Constants.SMB_DEFAULT_PORT,
      Constants.SMB_DEFAULT_PORT,
      true,
      false,
      false
   ), //SMB
   SHAREPOINT: transportType('SharePoint', 'SharePoint', -1, -1, false, false, false),
   WORKDRIVE: transportType('Zoho WorkDrive', 'Zoho WorkDrive', -1, -1, false, false, false),
});
